export class ApkScriptSourceBuilder {
  static getScriptSource(isDirect: boolean | undefined, environment: string | undefined): string {
    const defaultScriptName = isDirect ? 'tuz-apk-manager-hfs-direct.js' : 'tuz-apk-manager.js';
    let baseUrl: string;
    let env: string;

    switch (environment ?? 'testing') {
      case 'test':
        baseUrl = 'https://apk-manager-front.int-test.tuz.pl/';
        env = 'staging';
        break;
      case 'testing':
        baseUrl = 'https://apk-manager-front.int-testing.tuz.pl/';
        env = 'testing';
        break;
      case 'prod':
        baseUrl = 'https://apk-manager-front.tuz.pl/';
        env = 'production'
        break;
      default:
        baseUrl = 'https://apk-manager-front.int-test.tuz.pl/';
        env = 'staging';
    }
    return baseUrl + 'assets/scripts/env/' + env + '/' + defaultScriptName;
  }
}
